/**
 * HR help text shared by screens that several modules reuse: the employee
 * pickers, consent requests, import dialogs, and the roster step forms.
 */

const employeeSelection = {
  employment_id: "Employee this applies to.",
  employment_ids: "Employees this applies to. Only the employees selected here are affected.",
  branch_id: "Narrow the employee list to these branches. It filters who you can pick, not who is affected.",
  department_id: "Narrow the employee list to these departments, including the departments beneath them.",
  designation_id: "Narrow the employee list to these designations.",
  grade_id: "Narrow the employee list to these grades.",
  location_id: "Narrow the employee list to these locations.",
  start_date: "First day of the period this applies to.",
  end_date: "Last day of the period this applies to.",
  days: "Which weekdays inside the selected range are affected. Only the ticked days are used.",
  time_slot_id: "Time slot giving the shift its start and end times, grace minutes, and overtime settings.",
  is_full_overtime_shift: "Treat the whole shift as overtime, so every worked minute is paid through the overtime policy instead of counting as normal duty.",
};

const consent = {
  employment_id: "Colleague you want an opinion from before this request moves forward. They receive it as a consent request.",
  message: "What you want to ask them. They see this text with the request.",
};

const importData = {
  file_attachment: "Excel file to import. Download the sample first so the columns match; rows that do not match an existing employee or master record are rejected.",
};

export const sharedTooltips = { employeeSelection, consent, importData };
export default sharedTooltips;
